<div class="canvas-parent">
  <canvas #bookingsAndRevenues></canvas>
</div>